import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import copyTextToClipboard from 'ggApp/utils/copyToClipboard';
import { fireEvent } from 'ggApp/modules/inwebview_api';
import { ShareButton, ShareIcon } from './styles';
import ProductSharerModal from './modal';

const ShareProduct = ({ message, link, isMobile, className, onClick, onCancel, onShared }) => {
    const [modal, setModal] = useState(null);

    const createModalRef = useCallback((newModal) => {
        setModal(newModal);
    }, []);

    const showModal = useCallback(() => {
        if (modal) {
            if (modal) {
                modal.openModal();
            }
        }
    }, [modal]);

    // eslint-disable-next-line consistent-return
    const shareContent = useCallback(() => {
        onClick();
        const shareOptions = {
            title: '',
            text: message,
            url: link,
        };
        if (window.ReactNativeWebView) {
            return fireEvent('SHARE', { shareOptions: { ...shareOptions, message } });
        }
        if (!navigator || !navigator.share || !isMobile) {
            copyTextToClipboard({ text: link });
            return showModal();
        }
        navigator
            .share(shareOptions)
            .then(() => {
                onShared('Native');
            })
            .catch(() => {
                onCancel();
            });
    }, [link, message, showModal, onClick, onShared, onCancel, isMobile]);
    return (
        <>
            <ShareButton className={className} onClick={shareContent}>
                <ShareIcon />
            </ShareButton>
            <ProductSharerModal
                modalRef={createModalRef}
                isMobile={isMobile}
                link={link}
                message={message}
                onShared={onShared}
                onCancel={onCancel}
            />
        </>
    );
};

ShareProduct.propTypes = {
    message: PropTypes.string,
    className: PropTypes.string,
    link: PropTypes.string,
    isMobile: PropTypes.bool,
    onClick: PropTypes.func,
    onCancel: PropTypes.func,
    onShared: PropTypes.func,
};

ShareProduct.defaultProps = {
    className: '',
    message: '',
    link: '',
    isMobile: true,
    onClick: () => {},
    onCancel: () => {},
    onShared: () => {},
};

export default ShareProduct;
